export default __webpack_public_path__ + "static/media/curbside_checkin.cb3e6df3.svg";